export default {
  conselheiros: [],
  conselheiro: {},
  mandatos: [],
  pagination: {},
  loading: false,
};
